import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ShiveRoutes } from '../routing/segments/route-segments';

export const confirmCreateInvoiceGuard: CanActivateFn = () => {
  const router = inject(Router);

  // One-time bypass when coming from the dialog
  const skip = router.currentNavigation()?.extras.state?.[skipCreateConfirm] === true;

  if (skip) {
    return true; // allow activation without dialog
  }
  return router.createUrlTree([ShiveRoutes.FinancesInvoicesOverview], {
    queryParams: { [openCreateDialogQueryParam]: 1 },
  });
};

export const skipCreateConfirm = 'skipCreateConfirm';
export const openCreateDialogQueryParam = 'open-create-dialog';
